import { http } from "../../utils/config";


const getStatusText = (status) => {
  const map = {
    PLANNED: "Đã lên kế hoạch",
    ONGOING: "Đang diễn ra",
    CLOSED: "Đã kết thúc",
  };
  return map[status] || status;
};

const collectionAPI = {
  // Get all collections with pagination and search
  getCollections: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      status = '',
      sort_by = 'created_at',
      sort_order = 'desc',
      start_date = '',
      end_date = '',
      parent_id = '',
      type_child = '',
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(status !== '' && { status }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(parent_id !== '' && { parent_id: parent_id === null ? 'null' : parent_id.toString() }),
      ...(type_child && { type_child }),
    });

    return http.get(`/api/v1/collections?${queryParams}`);
  },

  getDashboard: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      sort_by = 'created_at',
      sort_order = 'desc',
      start_date = '',
      end_date = ''
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date })
    });

    return http.get(`/api/v1/collections/get-dashboard?${queryParams}`);
  },

  // Get collection by ID
  getCollectionById: (id) => {
    return http.get(`/api/v1/collections/${id}`);
  },

  // Create new collection
  createCollection: (collectionData) => {
    return http.post('/api/v1/collections', collectionData);
  },

  // Update collection
  updateCollection: (id, collectionData) => {
    return http.put(`/api/v1/collections/${id}`, collectionData);
  },

  // Tiến độ cập nhật đợt thu chạy nền. Đợt thu lớn (>1000 dòng) backend trả 202 kèm
  // queued=true và xử lý ở queue, FE poll endpoint này tới khi DONE hoặc FAILED.
  getUpdateStatus: (id) => {
    return http.get(`/api/v1/collections/${id}/update-status`);
  },

  // Delete collection
  deleteCollection: (id) => {
    return http.delete(`/api/v1/collections/${id}`);
  },

  // Toggle collection status
  toggleCollectionStatus: (id, status) => {
    return http.post(`/api/v1/collections/${id}/status`, {
      status: status
    });
  },

  // Danh sách đợt thu rút gọn (id, name) cho ô chọn lọc — cùng phạm vi quyền với màn đợt thu
  getCollectionOptions: (params = {}) => {
    return http.get('/api/v1/collections/options', { params });
  },

  // Get collection statistics
  getCollectionStats: (id) => {
    return http.get(`/api/v1/collections/${id}/stats`);
  },

  // Bulk delete collections
  bulkDeleteCollections: (ids) => {
    return http.delete('/api/v1/collections/bulk', {
      data: { ids }
    });
  },

  // Export collections to Excel
  exportCollections: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return http.get(`/api/v1/datamanagement/export/collections?${queryParams}`, {
      responseType: 'blob'
    });
  },

  exportCollectionByID: (id) => {
    return http.get(`/api/v1/datamanagement/export/collections/${id}`, {
      responseType: 'blob'
    });
  },

  exportCollectionParentByID: (id) => {
    return http.get(`/api/v1/datamanagement/export/collections/parent/${id}`, {
      responseType: 'blob'
    });
  },

  // Import collections from Excel
  importCollections: (file) => {
    const formData = new FormData();
    formData.append('file', file);

    return http.post('/api/v1/collections/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Search collections with advanced filters
  searchCollections: (filters) => {
    return http.post('/api/v1/collections/search', filters);
  },

  // Duplicate collection
  duplicateCollection: (id, options = {}) => {
    return http.post(`/api/v1/collections/${id}/duplicate`, options, {
      // Đợt cỡ phường 8.000 dòng mất khoảng 20 giây ở máy chủ, chạm đúng timeout 20s mặc
      // định trong utils/config.js nên axios huỷ request giữa chừng — trong khi PHP vẫn
      // chạy tiếp tới lúc xong và ghi đủ dữ liệu. Người dùng thấy báo lỗi rồi bấm lại là
      // ra hai bản sao. Cho hạn rộng để nhận đúng kết quả thật từ máy chủ.
      timeout: 120000,
    });
  },

  // Cancel single transaction
  cancelSingleTransaction: (feeId) => {
    return http.post(`/api/v1/collections/cancel-single-transaction/${feeId}`);
  },

  // Gia hạn giao dịch thanh toán cho đợt quá hạn (đợt cha: áp cho mọi đợt con)
  extendPayment: (id, paymentExpDate) => {
    return http.post(`/api/v1/collections/${id}/extend-payment`, {
      payment_exp_date: paymentExpDate,
    });
  },

  // Cancel a customer fee item (CANCELLED)
  cancelCustomerFee: (feeId, data) => {
    return http.post(`/api/v1/collections/fees/${feeId}/cancel`, data);
  },

  // Xóa mềm khoản thu đặc biệt — cần quyền collections.deleteFee, data: { delete_reason }
  deleteCustomerFee: (feeId, data) => {
    return http.post(`/api/v1/collections/fees/${feeId}/delete`, data);
  },

  // // Add a single customer fee into a collection
  // addCustomerFeeToCollection: (collectionId, data) => {
  //   return http.post(`/api/v1/collections/${collectionId}/fees/add`, data);
  // },

  // Update customer fee (Số tiền, tài sản)
  updateCustomerFee: (feeId, data) => {
    return http.put(`/api/v1/collections/fees/${feeId}`, data);
  },

  getCollectionForCustomers: (id, params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      sort_by = 'created_at',
      sort_order = 'desc',
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
    });

    return http.get(`/api/v1/collections/customers/${id}?${queryParams}`);
  },

  getCusFees: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      sort_by = 'created_at',
      sort_order = 'desc',
      overdue_range = "",
      start_date = '',
      end_date = ''
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(overdue_range && { overdue_range }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date })
    });

    return http.get(`/api/v1/collections/fees?${queryParams}`);
  },

  getOverdueDashboard: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      sort_by = 'created_at',
      sort_order = 'desc',
      overdue_range = "",
      start_date = '',
      end_date = ''
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(overdue_range && { overdue_range }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date })
    });

    return http.get(`/api/v1/collections/get-overdue-dashboard?${queryParams}`);
  },

  importCollectionTarget: (formData) => {
    return http.post('/api/v1/tagert/file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
};

// Helper functions for handling API responses
export const collectionHelpers = {
  // Extract collection data from API response
  extractCollectionData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  // Extract paginated collection list from API response
  extractCollectionList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        collections: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
          nextPageUrl: data.next_page_url,
          prevPageUrl: data.prev_page_url
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

    extractCusFeeList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        fees: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
          nextPageUrl: data.next_page_url,
          prevPageUrl: data.prev_page_url
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  // Format collection data for form submission
  formatCollectionData: (formData) => {
    return {
      name: formData.name?.trim(),
      description: formData.description?.trim(),
      start_date: formData.start_date,
      end_date: formData.end_date,
      status: formData.status ?? "PLANNED",
      customer_fees: formData.customer_fees || [],
      fee_definitions: formData.fee_definitions || [],
      is_send_zns: formData.is_send_zns,
      send_schedule_at:formData.send_schedule_at,
      before_date: formData.before_date,
      after_date: formData.after_date,
      send_date: formData.send_date,
      charge_target_type: formData.charge_target_type,
      collection_category_id: formData.collection_category_id,
      is_locked: formData.is_locked ?? true,
      // invoice_cnf_id: formData.invoice_cnf_id,
      transfer_content: formData.transfer_content,
    };
  },

  // Validate collection data before submission
  validateCollectionData: (collectionData) => {
    const errors = {};

    if (!collectionData.name?.trim()) {
      errors.name = 'Tên đợt thu không được để trống';
    }

    if (!collectionData.start_date) {
      errors.start_date = 'Ngày bắt đầu không được để trống';
    }

    if (!collectionData.end_date) {
      errors.end_date = 'Ngày kết thúc không được để trống';
    }

    if (collectionData.start_date && collectionData.end_date) {
      const startDate = new Date(collectionData.start_date);
      const endDate = new Date(collectionData.end_date);

      if (endDate <= startDate) {
        errors.end_date = 'Ngày kết thúc phải sau ngày bắt đầu';
      }
    }

    if (collectionData.description && collectionData.description.length > 1000) {
      errors.description = 'Mô tả không được vượt quá 1000 ký tự';
    }

    // Validate customer_fees
    if (!collectionData.customer_fees || collectionData.customer_fees.length === 0) {
      errors.customer_fees = 'Phải có ít nhất một khách hàng trong đợt thu';
    } else {
      collectionData.customer_fees.forEach((customerFee, index) => {
        if (!customerFee.customer_id) {
          errors[`customer_fees.${index}.customer_id`] = 'ID khách hàng không được để trống';
        }

        if (!customerFee.fees || typeof customerFee.fees !== 'object') {
          errors[`customer_fees.${index}.fees`] = 'Danh sách phí không hợp lệ';
        } else {
          // Validate fees values
          Object.entries(customerFee.fees).forEach(([feeType, amount]) => {
            if (typeof amount !== 'number' || amount < 0) {
              errors[`customer_fees.${index}.fees.${feeType}`] = 'Số tiền phải là số không âm';
            }
          });
        }
        
        if (!customerFee.acc_payment_id) {
          errors[`customer_fees.${index}.acc_payment_id`] = 'ID tài khoản thanh toán không được để trống';
        }
      });
    }

    if (!collectionData.charge_target_type) {
      errors.charge_target_type = 'Vui lòng chọn nhóm đối tượng!';
    }

    // if (!collectionData.invoice_cnf_id) {
    //   errors.invoice_cnf_id = 'Vui lòng chọn tài khoản xuất hóa đơn!';
    // }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },


  // Format collection for display
  formatCollectionForDisplay: (collection) => {
    return {
      ...collection,
      // statusText: collection.status ? 'Đang hoạt động' : 'Đã kết thúc',
      statusText: getStatusText(collection.status),
      startDate: new Date(collection.start_date).toLocaleDateString('vi-VN'),
      endDate: new Date(collection.end_date).toLocaleDateString('vi-VN'),
      createdAt: new Date(collection.created_at).toLocaleDateString('vi-VN'),
      updatedAt: new Date(collection.updated_at).toLocaleDateString('vi-VN'),
      totalCustomers: collection.customer_fees?.length || 0,
      totalAmount: collection.customer_fees?.reduce((total, customerFee) => {
        return total + Object.values(customerFee.fees).reduce((sum, fee) => sum + fee, 0);
      }, 0) || 0
    };
  },

  // Calculate collection statistics
  // calculateCollectionStats: (collection) => {
  //   if (!collection.customer_fees || collection.customer_fees.length === 0) {
  //     return {
  //       totalCustomers: 0,
  //       totalAmount: 0,
  //       feeBreakdown: {},
  //       averagePerCustomer: 0
  //     };
  //   }

  //   const feeBreakdown = {};
  //   let totalAmount = 0;

  //   collection.customer_fees.forEach(customerFee => {
  //     Object.entries(customerFee.fees).forEach(([feeType, amount]) => {
  //       if (!feeBreakdown[feeType]) {
  //         feeBreakdown[feeType] = 0;
  //       }
  //       feeBreakdown[feeType] += amount;
  //       totalAmount += amount;
  //     });
  //   });

  //   return {
  //     totalCustomers: collection.customer_fees.length,
  //     totalAmount,
  //     feeBreakdown,
  //     averagePerCustomer: totalAmount / collection.customer_fees.length
  //   };
  // },

  // Validate fee structure
  validateFeeStructure: (fees) => {
    const errors = {};
    const allowedFeeTypes = ['K1', 'K2', 'K3']; // Có thể customize theo yêu cầu

    Object.entries(fees).forEach(([feeType, amount]) => {
      if (!allowedFeeTypes.includes(feeType)) {
        errors[feeType] = `Loại phí ${feeType} không được phép`;
      }

      if (typeof amount !== 'number' || amount < 0) {
        errors[feeType] = `Số tiền cho ${feeType} phải là số không âm`;
      }
    });

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  // Generate collection name suggestion
  generateCollectionName: (month, year) => {
    return `Đợt thu tháng ${month}/${year}`;
  },

  // Check if collection is active
  isCollectionActive: (collection) => {
    if (!collection.status) return false;

    const now = new Date();
    const startDate = new Date(collection.start_date);
    const endDate = new Date(collection.end_date);

    return now >= startDate && now <= endDate;
  },

  
  // Validate duplicate options
  validateDuplicateOptions: (options) => {
    const errors = {};

    if (options.name && options.name.trim().length === 0) {
      errors.name = 'Tên đợt thu không được để trống';
    }

    if (options.name && options.name.length > 255) {
      errors.name = 'Tên đợt thu không được vượt quá 255 ký tự';
    }

    if (options.start_date && options.end_date) {
      const startDate = new Date(options.start_date);
      const endDate = new Date(options.end_date);

      if (endDate <= startDate) {
        errors.end_date = 'Ngày kết thúc phải sau ngày bắt đầu';
      }
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  // Generate duplicate name
  generateDuplicateName: (originalName) => {
    const timestamp = new Date().toLocaleDateString('vi-VN');
    return `${originalName} (Sao chép ${timestamp})`;
  },
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401:
            throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403:
            throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404:
            throw new Error('Không tìm thấy đợt thu');
          case 409:
            throw new Error('Đợt thu trong khoảng thời gian này đã tồn tại');
          case 422:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500:
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.code === 'ECONNABORTED') {
        // Quá hạn chờ ở phía trình duyệt. Máy chủ KHÔNG dừng theo — PHP chạy tiếp tới lúc
        // xong và ghi đủ dữ liệu. Báo "không kết nối được" ở đây là nói sai: người dùng
        // tưởng thất bại rồi bấm lại, thành ra hai bản ghi.
        throw new Error(
          'Máy chủ xử lý lâu hơn dự kiến. Thao tác có thể vẫn đang chạy — hãy làm mới danh sách để kiểm tra trước khi thử lại.'
        );
      } else if (error.request) {
        // Network error
        throw new Error('Không thể kết nối đến server');
      } else {
        // Other error
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

// Wrapped API functions with error handling
export const collectionAPIWithErrorHandling = {
  getCollections: withErrorHandling(collectionAPI.getCollections),
  getDashboard: withErrorHandling(collectionAPI.getDashboard),
  getCollectionById: withErrorHandling(collectionAPI.getCollectionById),
  createCollection: withErrorHandling(collectionAPI.createCollection),
  updateCollection: withErrorHandling(collectionAPI.updateCollection),
  getUpdateStatus: withErrorHandling(collectionAPI.getUpdateStatus),
  deleteCollection: withErrorHandling(collectionAPI.deleteCollection),
  toggleCollectionStatus: withErrorHandling(collectionAPI.toggleCollectionStatus),
  getCollectionStats: withErrorHandling(collectionAPI.getCollectionStats),
  bulkDeleteCollections: withErrorHandling(collectionAPI.bulkDeleteCollections),
  exportCollections: withErrorHandling(collectionAPI.exportCollections),
  exportCollectionByID: withErrorHandling(collectionAPI.exportCollectionByID),
  exportCollectionParentByID: withErrorHandling(collectionAPI.exportCollectionParentByID),
  importCollections: withErrorHandling(collectionAPI.importCollections),
  searchCollections: withErrorHandling(collectionAPI.searchCollections),
  duplicateCollection: withErrorHandling(collectionAPI.duplicateCollection),
  cancelSingleTransaction: withErrorHandling(collectionAPI.cancelSingleTransaction),
  extendPayment: withErrorHandling(collectionAPI.extendPayment),
  getCollectionOptions: withErrorHandling(collectionAPI.getCollectionOptions),
  cancelCustomerFee: withErrorHandling(collectionAPI.cancelCustomerFee),
  deleteCustomerFee: withErrorHandling(collectionAPI.deleteCustomerFee),
  addCustomerFeeToCollection: withErrorHandling(collectionAPI.addCustomerFeeToCollection),
  updateCustomerFee: withErrorHandling(collectionAPI.updateCustomerFee),
  getCollectionForCustomers: withErrorHandling(collectionAPI.getCollectionForCustomers),
  getCusFees: withErrorHandling(collectionAPI.getCusFees),
  getOverdueDashboard: withErrorHandling(collectionAPI.getOverdueDashboard),
  importCollectionTarget: withErrorHandling(collectionAPI.importCollectionTarget)
};

export default collectionAPI;